import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { NewTag } from '../../../components/NewTag';

export const StyledSettingsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 16px 16px 12px;
  margin: 16px 0 24px 0;
  border: 1px solid ${colorsPalettes.carbon[50]};
  border-radius: 8px;
`;

export const StyledSettingsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSettingsItemTitleWrapper = styled.div`
  margin-right: 8px;
`;

export const StyledSettingsItemTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledSettingsItemIcon = styled(SWReactIcons)`
  flex: none;
  margin-right: 8px;
`;

export const StyledSettingsItemText = styled.p`
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
  margin: 0;
`;

export const StyledSettingsItemTextDescription = styled.p`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[250])};
  margin: 4px 24px;
`;

export const StyledNewTag = styled(NewTag)`
  margin-right: auto;
`;
